var m_speakerIcon = null;
var app = require('app').app;

var m_isCanvasVisible = false;

var appExports = {
    /**
     * The namespace represents an auxiliary interface.
     * 
     * @namespace
     * @memberof module:solo.app
     */
    ui: {
        /**
         * Set banner image over the 3D window.
         * 
         * @param {BannerImageInfo|HTMLImageElement} image - Banner image data (see {@link module:solo.app.util.fetchBannerImage app.util.fetchBannerImage()}) or Image object
         * @see {@link module:solo.app.util.fetchBannerImage app.util.fetchBannerImage()}
         * @see external:HTMLImageElement
         */
        setBannerImage: function (image) {
            if (!window.PanelService) return;
            if (image) window.PanelService.setBannerImage(image);
        },

        /**
         * Shows or hides the 3D window.
         * 
         * @param {boolean} [visible=true]
         */
        showCanvas: function (visible) {
            if (!Module.canvas) return;
            visible = (typeof visible == 'undefined') ? true : !!visible;
            Module.canvas.style.display = visible ? 'block' : 'none';
            var group = Module.canvas.parentNode.querySelector('#tiramisu-panel-group');
            if (group) {
                group.style.display = visible ? '' : 'none';
            }
            app.ui.showPanels(visible);
            m_isCanvasVisible = visible;
            if (visible) Cortona3DSolo.dispatch("core.didChangeLayout");
        },

        /**
         * Shows or hides the HTML panels in the 3D window.
         * 
         * @param {boolean} [visible=true]
         */
        showPanels: function (visible) {
            if (!window.PanelService) return;
            visible = (typeof visible == 'undefined') ? true : !!visible;
            window.PanelService.showPanels(visible);
        },

        /**
         * Checks the 2D illustration display mode.
         * 
         * @returns {boolean}
         */
        isDrawingDisplayMode: function () {
            var result = false;
            if (app.drawing) {
                result = app.drawing.isVisible() && !m_isCanvasVisible;
            }
            return result;
        },

        /**
         * Checks if the 3D window visible.
         * 
         * @returns {boolean}
         */
        isCanvasVisible: function () {
            return m_isCanvasVisible;
        },

        /**
         * Shows or hides the speaker icon.
         * 
         * @param {boolean} [visible]
         * @returns {boolean}
         */
        toggleSpeakerIcon: function (visible) {
            if (!window.PanelService) return;
            var div;
            visible = (typeof visible === 'undefined') ? !m_speakerIcon : visible;
            if (visible) {
                if (m_speakerIcon) return;
                div = document.createElement('div');
                div.className = 'tiramisu-speaker';
                div.appendChild(document.createElement('div'));
                div.appendChild(document.createElement('span'));
                div.appendChild(document.createElement('span'));
                div.appendChild(document.createElement('span'));
                window.PanelService.appendChild(div);
                m_speakerIcon = div;
                window.setTimeout(function () {
                    div.style.opacity = 1;
                }, 300);
            } else {
                div = m_speakerIcon;
                if (div) {
                    div.style.opacity = 0;
                    window.setTimeout(function () {
                        div.parentNode.removeChild(div);
                    }, 300);
                }
                m_speakerIcon = null;
            }
            return visible;
        }
    }
};

module.exports = {
    app: appExports
};